import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Star, Download, Send, Award, TrendingUp, Handshake, BadgeIndianRupee, Tag, PackageOpen, Headset,
  IndianRupee, Megaphone, CheckCircle2, Mail, MapPin, FileText, Store, Rocket, Quote, ChevronLeft,
  ChevronRight, Users, ChartNoAxesCombined, HandCoins, Timer, BadgeCheck, MoveRight,
} from "lucide-react";
import { toast } from "sonner";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { franchiseData as fd } from "../mockFranchise";
import { useStore } from "../context/StoreContext";
import { submitEnquiry as sendEnquiry } from "../api";

const NAVY = "#1B1F5C";
const SHOW_BROCHURE = false;
const galleryImages = [
  "https://customer-assets-v7afamib.emergentagent.net/job_appa-playtime/artifacts/11duxknn_02.png",
  "https://customer-assets-v7afamib.emergentagent.net/job_appa-playtime/artifacts/hii44o7b_04.png",
  "https://customer-assets-v7afamib.emergentagent.net/job_appa-playtime/artifacts/ruexjnax_03.png",
  "https://customer-assets-v7afamib.emergentagent.net/job_appa-playtime/artifacts/knlyjjmj_05.png",
  "https://customer-assets-v7afamib.emergentagent.net/job_appa-playtime/artifacts/j82g5hl5_06.png",
];
const icons = { Award, TrendingUp, Handshake, BadgeIndianRupee, Tag, PackageOpen, Headset, IndianRupee, Megaphone, Mail, MapPin, FileText, Store, Rocket, Users, ChartNoAxesCombined, HandCoins, Timer, BadgeCheck };

const DoodleStar = ({ className, color }) => (
  <svg className={className} viewBox="0 0 24 24" fill={color}><path d="M12 2l2.4 7.2L22 12l-7.6 2.8L12 22l-2.4-7.2L2 12l7.6-2.8z"/></svg>
);

const Franchise = () => {
  const { wishlist, cart } = useStore();
  const [tIdx, setTIdx] = useState(0);
  const [form, setForm] = useState({ name: "", mobile: "", city: "" });
  const [sending, setSending] = useState(false);

  const submitEnquiry = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.mobile.trim() || !form.city.trim()) {
      toast.error("Please fill all the fields");
      return;
    }
    if (!/^(\+91|91|0)?[6-9]\d{9}$/.test(form.mobile.replace(/[\s-]/g, ""))) {
      toast.error("Please enter a valid 10-digit Indian mobile number");
      return;
    }
    setSending(true);
    try {
      await sendEnquiry({
        name: form.name.trim(),
        phone: form.mobile.trim(),
        city: form.city.trim(),
        message: `Franchise enquiry from ${form.city.trim()}`,
        type: "franchise",
      });
      toast.success("Enquiry submitted! Our franchise team will connect with you within 24 hours.");
      setForm({ name: "", mobile: "", city: "" });
    } catch {
      toast.error("Could not submit your enquiry. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="bg-white min-h-screen">
      <Header cartCount={cart.length} wishlistCount={wishlist.length} />
      <main>
        {/* Breadcrumb */}
        <div className="max-w-7xl mx-auto px-4 pt-4 text-left">
          <p className="text-[12px] font-bold" style={{ color: NAVY }}>
            <Link to="/" className="hover:text-[#35C3C1] transition-colors">Home</Link>
            <span className="mx-2 text-gray-400">&gt;</span>
            <span>Our Franchise</span>
          </p>
        </div>

        {/* Hero */}
        <section className="max-w-7xl mx-auto px-4 mt-4 relative">
          <DoodleStar className="absolute -left-1 top-10 w-6 h-6 animate-float" color="#F79433" />
          <DoodleStar className="absolute right-2 top-2 w-7 h-7 animate-float-delay hidden md:block" color="#F79433" />
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div className="text-left relative">
              <span className="inline-flex items-center gap-1.5 bg-[#7C4DC4] text-white text-[11px] font-extrabold px-4 py-1.5 rounded-full">
                <Star size={11} className="fill-white" /> Build Joy, Build Success.
              </span>
              <h1 className="mt-4 font-display font-extrabold text-4xl md:text-5xl leading-[1.08]" style={{ color: NAVY }}>
                Partner with<br />
                Adhira <span className="text-[#F79433]">&</span> <span className="text-[#35C3C1]">Appa Toys</span>
              </h1>
              <p className="mt-4 text-[14.5px] font-semibold text-[#5A5A75] leading-relaxed max-w-md">
                India's trusted destination for premium quality toys that inspire play, learning and happiness.
              </p>
              {/* mini badges */}
              <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-4">
                {fd.heroBadges.map((b) => {
                  const Icon = icons[b.icon];
                  return (
                    <div key={b.title} className="flex items-start gap-2">
                      <span className="h-8 w-8 rounded-full border border-gray-200 flex items-center justify-center shrink-0 mt-0.5">
                        <Icon size={15} style={{ color: NAVY }} strokeWidth={1.8} />
                      </span>
                      <div className="leading-tight">
                        <p className="text-[11.5px] font-extrabold" style={{ color: NAVY }}>{b.title}</p>
                        <p className="text-[10.5px] font-semibold text-gray-500 whitespace-pre-line">{b.desc}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="mt-7 flex flex-wrap gap-4">
                <a href="#franchise-form" className="px-7 h-12 rounded-full text-white text-[12px] font-extrabold tracking-widest shadow-lg inline-flex items-center hover:-translate-y-0.5 transition-transform" style={{ backgroundColor: NAVY }}>
                  APPLY FOR FRANCHISE
                </a>
                {SHOW_BROCHURE && (
                <button
                  onClick={() => toast.success("Brochure download will start shortly!")}
                  className="px-7 h-12 rounded-full border-2 border-gray-300 text-[12px] font-extrabold tracking-widest inline-flex items-center gap-2 hover:border-[#35C3C1] transition-colors"
                  style={{ color: NAVY }}
                >
                  DOWNLOAD BROCHURE <Download size={15} />
                </button>
                )}
              </div>
              <Send size={30} className="absolute top-2 right-6 text-[#1B1F5C] -rotate-12 hidden lg:block" strokeWidth={1.5} />
            </div>

            {/* Hero video */}
            <div className="relative">
              <div className="rounded-[40px] overflow-hidden rounded-tl-[120px] shadow-lg bg-[#1B1F5C]">
                <video
                  className="w-full h-[320px] md:h-[400px] object-cover"
                  autoPlay
                  muted
                  loop
                  playsInline
                  poster={fd.heroImage}
                  data-testid="franchise-hero-video"
                >
                  <source src="/videos/franchise-hero.mp4" type="video/mp4" />
                  <source src="/videos/franchise-hero.webm" type="video/webm" />
                </video>
              </div>
              <span className="absolute top-3 right-3 h-11 w-11 rounded-full flex items-center justify-center shadow-lg" style={{ backgroundColor: NAVY }}>
                <Star size={18} className="text-[#FCD44E] fill-[#FCD44E]" />
              </span>
              <div className="absolute bottom-4 right-4 md:bottom-8 md:right-6 h-32 w-32 md:h-40 md:w-40 rounded-full bg-[#35C3C1] text-white flex flex-col items-center justify-center text-center p-4 shadow-xl rotate-6 border-4 border-white">
                <p className="text-[10px] font-bold">Be a part of a</p>
                <p className="font-display font-extrabold text-[15px] md:text-[17px] leading-tight">Happy<br />Playful<br />Profitable</p>
                <p className="text-[10px] font-bold">Journey!</p>
              </div>
            </div>
          </div>
        </section>

        {/* Why Partner */}
        <section className="max-w-7xl mx-auto px-4 mt-14 relative">
          <DoodleStar className="absolute left-0 -top-2 w-7 h-7" color="#35C3C1" />
          <DoodleStar className="absolute right-0 top-0 w-8 h-8" color="#F0426A" />
          <div className="flex items-center justify-center gap-3">
            <h2 className="font-display font-extrabold text-2xl md:text-[30px]" style={{ color: NAVY }}>Why Partner with Us?</h2>
            <DoodleStar className="w-4 h-4" color="#F79433" />
          </div>
          <div className="mt-7 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {fd.whyPartner.map((w) => {
              const Icon = icons[w.icon];
              return (
                <div key={w.title} className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-lg hover:-translate-y-1 transition-transform duration-200 px-4 py-6 flex flex-col items-center text-center">
                  <span className="h-12 w-12 rounded-full border-2 border-gray-200 flex items-center justify-center mb-3">
                    <Icon size={20} style={{ color: NAVY }} strokeWidth={1.7} />
                  </span>
                  <p className="text-[12.5px] font-extrabold" style={{ color: NAVY }}>{w.title}</p>
                  <p className="mt-1.5 text-[11px] font-semibold text-gray-500 leading-snug">{w.desc}</p>
                </div>
              );
            })}
          </div>
        </section>

        {/* Franchise Models */}
        <section className="max-w-7xl mx-auto px-4 mt-14 relative">
          <div className="flex items-center justify-center gap-3">
            <DoodleStar className="w-4 h-4" color="#F79433" />
            <h2 className="font-display font-extrabold text-2xl md:text-[30px]" style={{ color: NAVY }}>Franchise Models</h2>
            <DoodleStar className="w-4 h-4" color="#35C3C1" />
          </div>
          <p className="text-[13.5px] font-semibold text-gray-500 mt-1.5 text-center">Choose the model that fits your business goals</p>
          <div className="mt-7 grid md:grid-cols-3 gap-6">
            {fd.models.map((m) => (
              <div key={m.name} className="bg-white rounded-3xl border border-gray-100 shadow-md overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-transform duration-200">
                <div className="py-4 text-center text-white" style={{ backgroundColor: m.headerColor }}>
                  <p className="font-display font-extrabold text-lg">{m.name}</p>
                  <p className="text-[12px] font-bold opacity-90">{m.size}</p>
                </div>
                <div className="px-5 pt-4">
                  <img src={m.image} alt={m.name} className="w-full h-40 object-cover rounded-xl" />
                </div>
                <div className="p-5 text-left">
                  <ul className="space-y-2.5">
                    {m.points.map((pt) => (
                      <li key={pt} className="flex items-center gap-2 text-[12.5px] font-bold" style={{ color: NAVY }}>
                        <CheckCircle2 size={15} className="text-[#35C3C1] shrink-0" /> {pt}
                      </li>
                    ))}
                  </ul>
                  <div className="mt-5 flex items-center justify-end">
                    <a href="#franchise-form" className="px-4 h-9 rounded-full border-2 text-[10.5px] font-extrabold tracking-widest inline-flex items-center hover:text-white transition-colors know-more-btn" style={{ borderColor: NAVY, color: NAVY }}
                       onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = NAVY; e.currentTarget.style.color = "#fff"; }}
                       onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "transparent"; e.currentTarget.style.color = NAVY; }}>
                      KNOW MORE
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Store gallery marquee */}
        <section className="mt-14 overflow-hidden" data-testid="franchise-gallery">
          <div className="flex items-center justify-center gap-3 px-4">
            <DoodleStar className="w-4 h-4" color="#35C3C1" />
            <h2 className="font-display font-extrabold text-2xl md:text-[30px]" style={{ color: NAVY }}>Step Inside Our World</h2>
            <DoodleStar className="w-4 h-4" color="#35C3C1" />
          </div>
          <p className="mt-2 text-center text-[13px] font-semibold text-gray-500 px-4">A glimpse of the joyful store experiences we're building.</p>
          <div className="mt-7 relative">
            <div className="flex gap-5 w-max animate-marquee">
              {[...galleryImages, ...galleryImages].map((img, i) => (
                <div key={i} className="w-[300px] md:w-[420px] shrink-0 rounded-3xl overflow-hidden shadow-lg">
                  <img src={img} alt="Adhira & Appa Toys store experience" className="h-[190px] md:h-[260px] w-full object-cover hover:scale-105 transition-transform duration-500" loading="lazy" />
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* 6-Step Process */}
        <section className="max-w-7xl mx-auto px-4 mt-14">
          <div className="flex items-center justify-center gap-3">
            <DoodleStar className="w-4 h-4" color="#F79433" />
            <h2 className="font-display font-extrabold text-2xl md:text-[30px]" style={{ color: NAVY }}>Our Simple 6-Step Process</h2>
            <DoodleStar className="w-4 h-4" color="#F79433" />
          </div>
          <div className="mt-9 flex flex-wrap justify-center gap-y-8">
            {fd.steps.map((s, i) => {
              const Icon = icons[s.icon];
              return (
                <React.Fragment key={s.num}>
                  <div className="flex flex-col items-center w-[150px] md:w-[140px]">
                    <span className="h-[74px] w-[74px] rounded-full flex items-center justify-center border-[3px]" style={{ borderColor: s.color, backgroundColor: `${s.color}18` }}>
                      <Icon size={28} style={{ color: s.color }} strokeWidth={1.7} />
                    </span>
                    <p className="mt-3 text-[13.5px] font-extrabold" style={{ color: NAVY }}>{s.num}</p>
                    <p className="mt-1 text-[11px] font-semibold text-gray-500 text-center whitespace-pre-line leading-snug">{s.desc}</p>
                  </div>
                  {i < fd.steps.length - 1 && (
                    <div className="hidden xl:flex items-center h-[74px] px-1 text-gray-300">
                      <MoveRight size={22} strokeWidth={1.5} className="opacity-60" style={{ strokeDasharray: "3 3" }} />
                    </div>
                  )}
                </React.Fragment>
              );
            })}
          </div>
        </section>

        {/* Testimonial + stats */}
        <section className="max-w-7xl mx-auto px-4 mt-14 grid lg:grid-cols-[1.2fr_2fr] gap-5">
          <div className="rounded-3xl p-7 md:p-8 text-left text-white relative flex flex-col" style={{ backgroundColor: NAVY }}>
            <h3 className="font-display font-extrabold text-xl">Our Promise to Partners</h3>
            <Quote size={26} className="mt-4 text-[#FCD44E] fill-[#FCD44E] rotate-180" />
            <p className="mt-2 text-[13.5px] font-semibold leading-relaxed flex-1">{fd.testimonials[tIdx].quote}</p>
            <p className="mt-4 text-[12.5px] font-extrabold">– {fd.testimonials[tIdx].name}</p>
            <p className="text-[11.5px] font-semibold text-white/60">{fd.testimonials[tIdx].role}</p>
            <div className="mt-5 flex items-center justify-between">
              <div className="flex gap-2">
                <button onClick={() => setTIdx((tIdx + fd.testimonials.length - 1) % fd.testimonials.length)} className="h-8 w-8 rounded-full bg-white/15 flex items-center justify-center hover:bg-white/30 transition-colors" aria-label="Previous testimonial">
                  <ChevronLeft size={15} />
                </button>
                <button onClick={() => setTIdx((tIdx + 1) % fd.testimonials.length)} className="h-8 w-8 rounded-full bg-white/15 flex items-center justify-center hover:bg-white/30 transition-colors" aria-label="Next testimonial">
                  <ChevronRight size={15} />
                </button>
              </div>
              <div className="flex gap-1.5">
                {fd.testimonials.map((_, i) => (
                  <span key={i} className={`h-1.5 rounded-full transition-colors ${i === tIdx ? "w-4 bg-[#FCD44E]" : "w-1.5 bg-white/40"}`} />
                ))}
              </div>
            </div>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
            {fd.stats.map((s) => {
              const Icon = icons[s.icon];
              return (
                <div key={s.value} className="rounded-3xl p-6 flex flex-col items-center justify-center text-center" style={{ backgroundColor: s.bg }}>
                  <Icon size={40} style={{ color: s.color }} strokeWidth={1.4} />
                  <p className="mt-3 font-display font-extrabold text-2xl md:text-[26px]" style={{ color: s.color }}>{s.value}</p>
                  <p className="mt-1 text-[12px] font-extrabold whitespace-pre-line leading-snug" style={{ color: NAVY }}>{s.label}</p>
                </div>
              );
            })}
          </div>
        </section>

        {/* Enquiry Form */}
        <section id="franchise-form" className="max-w-7xl mx-auto px-4 mt-12 mb-4 scroll-mt-24">
          <div className="rounded-3xl px-6 md:px-10 py-8 relative overflow-hidden" style={{ backgroundColor: NAVY }}>
            <img
              src="https://images.pexels.com/photos/14052497/pexels-photo-14052497.jpeg?auto=compress&w=400"
              alt="Teddy bear"
              className="absolute -right-4 bottom-0 h-40 w-40 object-cover rounded-tl-3xl opacity-90 hidden lg:block"
            />
            <div className="grid lg:grid-cols-[1fr_2fr] gap-6 items-center relative z-10">
              <div className="text-left">
                <h3 className="font-display font-extrabold text-xl md:text-2xl text-white leading-snug">Ready to Build a Successful Business with Us?</h3>
                <p className="mt-2 text-[12.5px] font-semibold text-white/70">Fill the form and our franchise team will connect with you!</p>
              </div>
              <form onSubmit={submitEnquiry} className="grid sm:grid-cols-[1fr_1fr_1fr_auto] gap-3 items-end">
                <div className="text-left">
                  <label className="block text-[11px] font-extrabold text-white/80 mb-1.5">Your Name</label>
                  <input data-testid="franchise-name-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Enter your name" className="w-full h-10 px-3.5 rounded-lg bg-white text-[12.5px] font-semibold outline-none text-gray-700" />
                </div>
                <div className="text-left">
                  <label className="block text-[11px] font-extrabold text-white/80 mb-1.5">Mobile Number</label>
                  <input data-testid="franchise-mobile-input" value={form.mobile} onChange={(e) => setForm({ ...form, mobile: e.target.value })} placeholder="Enter mobile number" className="w-full h-10 px-3.5 rounded-lg bg-white text-[12.5px] font-semibold outline-none text-gray-700" />
                </div>
                <div className="text-left">
                  <label className="block text-[11px] font-extrabold text-white/80 mb-1.5">City</label>
                  <input data-testid="franchise-city-input" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} placeholder="Enter your city" className="w-full h-10 px-3.5 rounded-lg bg-white text-[12.5px] font-semibold outline-none text-gray-700" />
                </div>
                <button type="submit" disabled={sending} data-testid="franchise-submit-btn" className="h-10 px-5 rounded-lg bg-[#F79433] text-white text-[11.5px] font-extrabold tracking-wide hover:brightness-105 transition-colors whitespace-nowrap disabled:opacity-60">
                  {sending ? "SUBMITTING..." : "SUBMIT ENQUIRY"}
                </button>
              </form>
            </div>
            <div className="mt-6 flex flex-wrap gap-x-8 gap-y-3 relative z-10">
              {fd.formPerks.map((p) => {
                const Icon = icons[p.icon];
                return (
                  <div key={p.title} className="flex items-center gap-2.5">
                    <span className="h-9 w-9 rounded-full border border-white/30 flex items-center justify-center">
                      <Icon size={16} className="text-white" strokeWidth={1.7} />
                    </span>
                    <div className="text-left leading-tight">
                      <p className="text-[12px] font-extrabold text-white">{p.title}</p>
                      <p className="text-[10.5px] font-semibold text-white/60">{p.desc}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
      </main>
      <Footer hideNewsletter />
    </div>
  );
};

export default Franchise;
